import { setARIALabel, onPress } from './chunk-Z6A4GYXE.js';
import { useMedia } from './chunk-ZIBTY3GT.js';
import { FocusVisibleController } from './chunk-LOFOQRT3.js';
import { $$_next_template, $$_create_template } from 'maverick.js/dom';
import { defineElement, Component } from 'maverick.js/element';

var $$_templ = /* @__PURE__ */ $$_create_template(`<!$><div part="container"><div part="text">LIVE</div></div>`);
var LiveIndicator = class extends Component {
  constructor(instance) {
    super(instance);
    this.a = useMedia();
    new FocusVisibleController(instance);
  }
  onAttach(el) {
    const { live, liveEdge } = this.a.$store;
    setARIALabel(el, this.F.bind(this));
    this.setAttributes({
      tabindex: this.xh.bind(this),
      role: this.yh.bind(this),
      "data-live": live,
      "data-live-edge": liveEdge,
      "data-media-button": true
    });
  }
  onConnect(el) {
    onPress(el, this.G.bind(this));
  }
  F() {
    const { live } = this.a.$store;
    return live() ? "Go live" : null;
  }
  xh() {
    const { live } = this.a.$store;
    return live() ? 0 : null;
  }
  yh() {
    const { live } = this.a.$store;
    return live() ? "button" : null;
  }
  G(event) {
    const { liveEdge } = this.a.$store;
    if (liveEdge())
      return;
    this.a.remote.seekToLiveEdge(event);
  }
  render() {
    return $$_next_template($$_templ);
  }
};
LiveIndicator.el = defineElement({
  tagName: "media-live-indicator"
});

export { LiveIndicator };
